// extracted by mini-css-extract-plugin
export default {"error":"ErrorElement_error__NwjqQ"};